// Mock data for Bored Ape Yacht Club NFTs
export const boredApeYachtClubNfts = [
  {
    id: 9974,
    name: 'Bored Ape #9974',
    image: 'https://ipfs.io/ipfs/QmXHu7pFhp5sUJi1aajkmsgcFBuSK6y93mWz5czvY8A8hA',
    price: '72.5 ETH'
  },
  {
    id: 9973,
    name: 'Bored Ape #9973',
    image: 'https://ipfs.io/ipfs/QmNs7bSj8NyfHED8YjgFtQdvDKVhh72YDhDaHHMpcSkwfH',
    price: '71.8 ETH'
  },
  {
    id: 9949,
    name: 'Bored Ape #9949',
    image: 'https://ipfs.io/ipfs/QmVb1n7vGzuVcGDXojSu6vRmi9wgszz8i5CvFud8AkngCF',
    price: '73.2 ETH'
  },
  {
    id: 9972,
    name: 'Bored Ape #9972',
    image: 'https://ipfs.io/ipfs/QmSGmMwXdBXhdot38pSNg83myPjBNeDxF4vHkvLznm9y2Z',
    price: '72.9 ETH'
  },
  {
    id: 9948,
    name: 'Bored Ape #9948',
    image: 'https://ipfs.io/ipfs/QmUeAcuhFXkcXL6FVxAeTY4MguNuc282kpXQk4g2KxzmZk',
    price: '71.5 ETH'
  },
    
    {
  id: 9929,
  name: 'Bored Ape #9929',
  image: 'https://ipfs.io/ipfs/QmSv58fhtgWYgSY9twKK2Sup1TTTzrPWSZ7S2Urp1o87Gr',
  price: '71.8 ETH'
},
{
  id: 9998,
  name: 'Bored Ape #9998',
  image: 'https://ipfs.io/ipfs/QmZGe8geLZGaUA892xbVdEqw5NQmAQKkQegBhWSfxLaEQT',
  price: '72.3 ETH'
},
{
  id: 9981,
  name: 'Bored Ape #9981',
  image: 'https://ipfs.io/ipfs/QmVu8aaZkLntMm1ZN32J64CMqMLtxJVV3GFJGWeCjo7XGQ',
  price: '71.9 ETH'
},
{
  id: 9971,
  name: 'Bored Ape #9971',
  image: 'https://ipfs.io/ipfs/QmW44wbsGXSEvVYuCUzT7mhu9SACggQKcmMWo6Y1Mc1Qee',
  price: '72.1 ETH'
},
{
  id: 9947,
  name: 'Bored Ape #9947',
  image: 'https://ipfs.io/ipfs/QmcTiFvfsC6QUnZk8ZFonjTh1eBDV2jYrtLLWC2JMBtUpm',
  price: '72.4 ETH'
},
{
  id: 9928,
  name: 'Bored Ape #9928',
  image: 'https://ipfs.io/ipfs/QmNTY6VksfBbmJt18ebwvwYU3yQ8HjeRCFC3fpKEi5h8AC',
  price: '71.7 ETH'
},
{
  id: 9887,
  name: 'Bored Ape #9887',
  image: 'https://ipfs.io/ipfs/QmYjXSJiRyZAwgFAddtNKFb1NoEEFa5SnzfFSJPVJDJ3gN',
  price: '72.2 ETH'
},
{
  id: 9980,
  name: 'Bored Ape #9980',
  image: 'https://ipfs.io/ipfs/QmUV7G2UJmxfxxFfTXkaRExbkWAWgsUkycWqsE9fH58f9Y',
  price: '72.0 ETH'
},
{
  id: 9997,
  name: 'Bored Ape #9997',
  image: 'https://ipfs.io/ipfs/QmZQpSUgutRJc7dMjtBwZb2naFJEwAaU8Rb4a5fnQMih3G',
  price: '72.5 ETH'
},
{
  id: 9970,
  name: 'Bored Ape #9970',
  image: 'https://ipfs.io/ipfs/QmaQeTbdMGvHtJeDjix3NkwCqwQGqVRqir5ippwEeKvuvq',
  price: '71.6 ETH'
},
{
  id: 9946,
  name: 'Bored Ape #9946',
  image: 'https://ipfs.io/ipfs/QmQn9BnEMHrbqApJ59wDnFqEjtoZE6pKy4LoxFhWA7MKPw',
  price: '71.8 ETH'
},
{
  id: 9927,
  name: 'Bored Ape #9927',
  image: 'https://ipfs.io/ipfs/QmUebrurYa1jfZ3MHyQBVtSmCDCyH43c65c9DHCqnmSqq1',
  price: '72.3 ETH'
},
{
  id: 9886,
  name: 'Bored Ape #9886',
  image: 'https://ipfs.io/ipfs/QmdG7c8b6NdZMCgjGgqPTB4xNVNsGjhFjN6KpJgpeJryBE',
  price: '71.9 ETH'
},
{
  id: 9979,
  name: 'Bored Ape #9979',
  image: 'https://ipfs.io/ipfs/QmS4EcHmJyaHhrJ3LwPJcSjPzXQL5ssvSzSvgh7BjUx4zp',
  price: '72.1 ETH'
},
{
  id: 9996,
  name: 'Bored Ape #9996',
  image: 'https://ipfs.io/ipfs/QmNMjRbzWxPf6eeLC6UiuFecWFmU6Nq18CZutHmD4Gapbm',
  price: '72.4 ETH'
},
{
  id: 9969,
  name: 'Bored Ape #9969',
  image: 'https://ipfs.io/ipfs/QmNvEWSgmQP7qrpo9kxZyzGq95CZcq5sHDmSS8MD27mvF3',
  price: '71.7 ETH'
},
{
  id: 9945,
  name: 'Bored Ape #9945',
  image: 'https://ipfs.io/ipfs/QmcynJqBshVioNc4amdPonuQv8MDiVdjjkSh5ypbeBsByh',
  price: '72.2 ETH'
},
{
  id: 9926,
  name: 'Bored Ape #9926',
  image: 'https://ipfs.io/ipfs/QmPAjFkZiGSUfHkg7WCbkAZDpHa57QcEMwTe8fQzKemsAk',
  price: '72.0 ETH'
},
{
  id: 9885,
  name: 'Bored Ape #9885',
  image: 'https://ipfs.io/ipfs/QmWbTdyC4bdvY95CrctzXLdfmFKuvYTtkeqno2AP9cS1j9',
  price: '71.5 ETH'
},
{
  id: 9978,
  name: 'Bored Ape #9978',
  image: 'https://ipfs.io/ipfs/Qme1mgfFYATQhEwEMDLadU5jraWJbJRaE2gCGyZrmTgdZQ',
  price: '72.5 ETH'
},
{
  id: 9995,
  name: 'Bored Ape #9995',
  image: 'https://ipfs.io/ipfs/QmcZD1z2MNqXfrDyN8fryvoJEJyvAMoYH5vYtMW9yHwYKk',
  price: '71.6 ETH'
},
{
  id: 9968,
  name: 'Bored Ape #9968',
  image: 'https://ipfs.io/ipfs/QmcMTLxwK4SAJuYCaSUfEXQPEhAvsyQXp2X3CquKSmxDAg',
  price: '71.8 ETH'
},
{
  id: 9992,
  name: 'Bored Ape #9992',
  image: 'https://ipfs.io/ipfs/QmPediLJS4nYpf3T1Rtjnge2iawVf58WKjgnfQzkTGCj8g',
  price: '72.3 ETH'
},
{
  id: 9925,
  name: 'Bored Ape #9925',
  image: 'https://ipfs.io/ipfs/QmNq8R5rBtGKNJ5MVKiegWAcLkqDAEpukWfcKqBHzijK76',
  price: '71.9 ETH'
},
{
  id: 9944,
  name: 'Bored Ape #9944',
  image: 'https://ipfs.io/ipfs/QmXRcauUaH4SGr54BrL1g7N32S4jpfDiU7kbYYjyxhwaPH',
  price: '72.1 ETH'
},
{
  id: 9989,
  name: 'Bored Ape #9989',
  image: 'https://ipfs.io/ipfs/QmRixhzz7vuF7Lq1h9XrH8rCyL7kGBZRf3i79ArqDmk7eN',
  price: '72.4 ETH'
},
{
  id: 9999,
  name: 'Bored Ape #9999',
  image: 'https://ipfs.io/ipfs/QmejYePrutbfWEV8wA3ogTHi2cf2j6hoaPhZSc6vNE43nH',
  price: '71.7 ETH'
},
{
  id: 9884,
  name: 'Bored Ape #9884',
  image: 'https://ipfs.io/ipfs/QmaLZDb19J8RuXNP1ZJGnpmJxvuW9sU3vVoeiBRcL2ZyA4',
  price: '72.2 ETH'
},
{
  id: 9994,
  name: 'Bored Ape #9994',
  image: 'https://ipfs.io/ipfs/QmNVmFNmNU96CuGxZacK3pqRwiKbg1BVZ8j7zVUxj9JYQY',
  price: '72.0 ETH'
},
{
  id: 9977,
  name: 'Bored Ape #9977',
  image: 'https://ipfs.io/ipfs/QmRtEfaJPNXPrYsqMqj2YC8CjWhTiPgwiRYxCsKffYqX9R',
  price: '71.5 ETH'
},
{
  id: 9967,
  name: 'Bored Ape #9967',
  image: 'https://ipfs.io/ipfs/QmVvXQekNfb8BuvCQyHUcpj3FQPxqhjtaZhJC8TBwETgx1',
  price: '72.5 ETH'
},
{
  id: 9924,
  name: 'Bored Ape #9924',
  image: 'https://ipfs.io/ipfs/QmUtH4euX2VCBM3NE4MyeMtr94cuF6nFHmK2HV94NNhXsa',
  price: '71.6 ETH'
},
{
  id: 9991,
  name: 'Bored Ape #9991',
  image: 'https://ipfs.io/ipfs/QmdtSF6sZTxqe1GKKrdKMyZPzZrm7zVL5f7F5cV4zZFAT8',
  price: '71.8 ETH'
},
{
  id: 9943,
  name: 'Bored Ape #9943',
  image: 'https://ipfs.io/ipfs/Qmcifn4eycVY7fcRZoJcVxRFPVVjMEsuCPvHByskFYAyPi',
  price: '72.3 ETH'
},
{
  id: 9986,
  name: 'Bored Ape #9986',
  image: 'https://ipfs.io/ipfs/QmTuNQooKPJ8aF6aMvQpkUx4kV21ngUMe9HptJQpmJfR8e',
  price: '71.9 ETH'
},
{
  id: 9988,
  name: 'Bored Ape #9988',
  image: 'https://ipfs.io/ipfs/QmU7fZA7zVbSytGLWpMXDnCxF9s64VWVuKhuerzjtcX54X',
  price: '72.1 ETH'
},
{
  id: 9883,
  name: 'Bored Ape #9883',
  image: 'https://ipfs.io/ipfs/QmZV7xUkr57yo9iM1JNkvPc2SGaEmXdNZ9FQpn7fdUqhbC',
  price: '72.4 ETH'
},
{
  id: 9993,
  name: 'Bored Ape #9993',
  image: 'https://ipfs.io/ipfs/Qmc9a8HUENWiHTDov7SZ8Ncm4aFBSAwq4UgPkenHDvfTjY',
  price: '71.7 ETH'
},
{
  id: 9976,
  name: 'Bored Ape #9976',
  image: 'https://ipfs.io/ipfs/QmayveerapVYVZvQ1Rnv5SmheGM6AnhL56kubjnXW2uZM1',
  price: '72.2 ETH'
},
{
  id: 9966,
  name: 'Bored Ape #9966',
  image: 'https://ipfs.io/ipfs/QmbsHrhZF7x1mU2XLTXwwDvhn1DidR6wMXoExVRfeCqL1h',
  price: '72.0 ETH'
},
{
  id: 9942,
  name: 'Bored Ape #9942',
  image: 'https://ipfs.io/ipfs/QmdZeGEJTwkJMSsXgqAbgoxwmBJ8edXAo3T3cs5dKsdHYJ',
  price: '71.5 ETH'
},
{
  id: 9990,
  name: 'Bored Ape #9990',
  image: 'https://ipfs.io/ipfs/QmWLu7iWfQTNA3aY3PoJpxa9enTytwHAZ2AycT4dfWf2iz',
  price: '72.5 ETH'
},
{
  id: 9923,
  name: 'Bored Ape #9923',
  image: 'https://ipfs.io/ipfs/QmUVisgmaRkHYjgB33D2vG57qTxWmnLDgLBe4k4MZDfAX4',
  price: '71.6 ETH'
},
{
  id: 9987,
  name: 'Bored Ape #9987',
  image: 'https://ipfs.io/ipfs/QmW9mEm8XPw6heoMw8hYon81VaRC4F5m8D2fjJFtvwjCsJ',
  price: '71.8 ETH'
},
{
  id: 9882,
  name: 'Bored Ape #9882',
  image: 'https://ipfs.io/ipfs/QmTwfbsLxP3827d6kXtNMHzCeC2iPMmoTRL4yuyHSbtrZt',
  price: '72.3 ETH'
},
{
  id: 9985,
  name: 'Bored Ape #9985',
  image: 'https://ipfs.io/ipfs/QmUy2aSNBkEtRgiA8xCNDiyN6wALDRcbasia4jM7JLC1cv',
  price: '71.9 ETH'
},
{
  id: 9982,
  name: 'Bored Ape #9982',
  image: 'https://ipfs.io/ipfs/QmdkD8KyfLjXYayoAxLwmNHGi2hA835VArQr3tiCyToayx',
  price: '72.1 ETH'
},
{
  id: 9965,
  name: 'Bored Ape #9965',
  image: 'https://ipfs.io/ipfs/QmbQAiFTdw7jVraqht7Ljfeg51GssvjDp9iHrjA2sXaz57',
  price: '72.4 ETH'
},
{
  id: 9975,
  name: 'Bored Ape #9975',
  image: 'https://ipfs.io/ipfs/QmSyVka1v6CwBtCuKv8TnuKbpVEDMMDbTWto2jtfxxuVMK',
  price: '71.7 ETH'
},
{
  id: 9984,
  name: 'Bored Ape #9984',
  image: 'https://ipfs.io/ipfs/QmSQ5bUAZdxT3ny6u7kLWmbGUrvfB8u7R9Fz7vWS3YNunS',
  price: '72.2 ETH'
},
    {
  id: 9983,
  name: 'Bored Ape #9983',
  image: 'https://ipfs.io/ipfs/QmVwXXwoDGoJ1iqFg51SsvtQLXrMNFiKFy2GxRfPzn1Z91',
  price: '72.0 ETH'
},
{
  id: 9941,
  name: 'Bored Ape #9941',
  image: 'https://ipfs.io/ipfs/QmXC6j6yZVm8Dva3QeoF1XwG9MbuVEUntXeZswmCNu9JgU',
  price: '71.5 ETH'
},
{
  id: 9881,
  name: 'Bored Ape #9881',
  image: 'https://ipfs.io/ipfs/QmPg7LGbMwhigFda2DVWpHsDet4bVJexrHbNXfwfywHT7Y',
  price: '72.3 ETH'
},
{
  id: 9922,
  name: 'Bored Ape #9922',
  image: 'https://ipfs.io/ipfs/QmZPfprye8VJPGkDFQCUSeDprqUFxyHaVfrpZtN64F729r',
  price: '71.9 ETH'
},
{
  id: 9940,
  name: 'Bored Ape #9940',
  image: 'https://ipfs.io/ipfs/Qmd3bFT8j97C6cZM2ZdzVwrGJFW2DFuogaGBntdkWjn2Es',
  price: '72.1 ETH'
},
{
  id: 9962,
  name: 'Bored Ape #9962',
  image: 'https://ipfs.io/ipfs/QmNMCR56431gTCd9Qo6yrMPRgwcf7CQKcZT1rNGS3Yqja6',
  price: '72.4 ETH'
},
{
  id: 9921,
  name: 'Bored Ape #9921',
  image: 'https://ipfs.io/ipfs/QmWAGxnMEoGAdinkYYLpbgkfThWPscwNxV3SbrLgDmnrhq',
  price: '71.7 ETH'
},
{
  id: 9880,
  name: 'Bored Ape #9880',
  image: 'https://ipfs.io/ipfs/QmQELr3pRoQra3FxFMHchb2qe2cLZ2QwagRdogWAEsezzG',
  price: '72.2 ETH'
},
{
  id: 9939,
  name: 'Bored Ape #9939',
  image: 'https://ipfs.io/ipfs/QmZZgtDkziwxy1cyoo2Noh3vojcQHSqC1ox7G9EJThuZ2d',
  price: '72.0 ETH'
},
{
  id: 9961,
  name: 'Bored Ape #9961',
  image: 'https://ipfs.io/ipfs/QmQ19CcBeJnfSP5iJJfgz1xJTEqBQu7C8eEXGyi7GQLDvu',
  price: '71.5 ETH'
},
{
  id: 9920,
  name: 'Bored Ape #9920',
  image: 'https://ipfs.io/ipfs/QmZAfCQ16a2tTS3R9EDYAbg1SmbTMcPtk3YmF5b8nrJQVJ',
  price: '72.5 ETH'
},
{
  id: 9879,
  name: 'Bored Ape #9879',
  image: 'https://ipfs.io/ipfs/QmchEjG6veQT6HDW4sGFNvpdSrzB4ffyd68iaKqhxsfbEd',
  price: '71.6 ETH'
},
{
  id: 9938,
  name: 'Bored Ape #9938',
  image: 'https://ipfs.io/ipfs/QmY8JTCAXvr68iz5gVnCd5uGf8ymbXFYbASiWdbtV2iWEF',
  price: '71.8 ETH'
},
{
  id: 9919,
  name: 'Bored Ape #9919',
  image: 'https://ipfs.io/ipfs/QmbET9nJhCuN31sRtXshcj6VJbBMckboPdnnvRzRvYbQZX',
  price: '72.3 ETH'
},
{
  id: 9960,
  name: 'Bored Ape #9960',
  image: 'https://ipfs.io/ipfs/Qma1aZPn7iS1vxkfip6kjGjbA5EUPDaunsApJJ8mUt8pyT',
  price: '71.9 ETH'
},
{
  id: 9878,
  name: 'Bored Ape #9878',
  image: 'https://ipfs.io/ipfs/QmNpLVqkRc88EcVgiYmeY5fHba7MEcDUrXxCcx87HRgEc3',
  price: '72.1 ETH'
},
{
  id: 9937,
  name: 'Bored Ape #9937',
  image: 'https://ipfs.io/ipfs/QmYAM5FBvNt3xng9m5VBceQANcCozwF9yzG9rdHT4CzDzb',
  price: '72.4 ETH'
},
{
  id: 9918,
  name: 'Bored Ape #9918',
  image: 'https://ipfs.io/ipfs/Qmaj8eHwVtVMDrBp7RrX8Y5sYv6AcU3MDiUxyxWSb75PpL',
  price: '71.7 ETH'
},
{
  id: 9959,
  name: 'Bored Ape #9959',
  image: 'https://ipfs.io/ipfs/QmSSYzgfwV7AR8yfT7Ev5KZYnhpvBPCPQdTyjZ7TvvvKXW',
  price: '72.2 ETH'
},
{
  id: 9899,
  name: 'Bored Ape #9899',
  image: 'https://ipfs.io/ipfs/QmTpJePyM5FnVCPvC6W7FS7k3zaaEM7x7bHJT9SEU1a9eR',
  price: '72.0 ETH'
},
{
  id: 9877,
  name: 'Bored Ape #9877',
  image: 'https://ipfs.io/ipfs/QmNRtPqzeSa8PZz3npdNN9FoURHWoH2P4UCNsEH9ymH8t9',
  price: '71.5 ETH'
},
{
  id: 9936,
  name: 'Bored Ape #9936',
  image: 'https://ipfs.io/ipfs/QmcLzFho7TBazZ868EzsmLreSt6ErhdqHofUKa56sEc4p3',
  price: '72.5 ETH'
},
{
  id: 9917,
  name: 'Bored Ape #9917',
  image: 'https://ipfs.io/ipfs/QmXYthmL6YkqYFSS93uHYED238gk5eoijkLqRfp1r1NDfB',
  price: '71.6 ETH'
},
{
  id: 9958,
  name: 'Bored Ape #9958',
  image: 'https://ipfs.io/ipfs/QmergasVYr54cDYUdPi6iXYxP4ZorhLJwKQ9rkHjXdRydF',
  price: '71.8 ETH'
},
{
  id: 9898,
  name: 'Bored Ape #9898',
  image: 'https://ipfs.io/ipfs/QmUQdqVxn2Jhjvzog2mc3zGphtem5LBjjKGn8DHwNkKkaY',
  price: '72.3 ETH'
},
{
  id: 9876,
  name: 'Bored Ape #9876',
  image: 'https://ipfs.io/ipfs/QmNvXzuWsbHeWFcq2vxTmC9bh2G11o9Vz5pcEJQDKC8R8T',
  price: '71.9 ETH'
},
{
  id: 9916,
  name: 'Bored Ape #9916',
  image: 'https://ipfs.io/ipfs/QmYJ3KxdX8XNgoiedPvwyyG3227xDHFgs1daBBJtvCr8EW',
  price: '72.1 ETH'
},
{
  id: 9935,
  name: 'Bored Ape #9935',
  image: 'https://ipfs.io/ipfs/QmXW6qtfJLa9bPKHcwsyN2pZXoZvbvDk5Uqakzi6KTYRXY',
  price: '72.4 ETH'
},
{
  id: 9957,
  name: 'Bored Ape #9957',
  image: 'https://ipfs.io/ipfs/QmSyhSPMPuiNLWmDRKJShqasBeLpSowwPD3yy2ZFQuWULt',
  price: '71.7 ETH'
},
{
  id: 9897,
  name: 'Bored Ape #9897',
  image: 'https://ipfs.io/ipfs/Qmb7uyGniYpQJ9FjPjs2Gv1s8GUmN23WdkB2V4HAJzcD6o',
  price: '72.2 ETH'
},
{
  id: 9875,
  name: 'Bored Ape #9875',
  image: 'https://ipfs.io/ipfs/QmV5W8WfAgTs6bEwULygDfWYfPLkR1XRs4zDwHpZpkogfS',
  price: '72.0 ETH'
},
{
  id: 9915,
  name: 'Bored Ape #9915',
  image: 'https://ipfs.io/ipfs/QmeRH2bp3cbM3kuEWGn6nDV4BorUCgWpcnwwatkVr3nURw',
  price: '71.5 ETH'
},
{
  id: 9934,
  name: 'Bored Ape #9934',
  image: 'https://ipfs.io/ipfs/QmYY7pgjdvkLkpMzqNZN993YbYfPN8VZXLCskAvdNwJCXW',
  price: '72.5 ETH'
},
{
  id: 9956,
  name: 'Bored Ape #9956',
  image: 'https://ipfs.io/ipfs/QmXi74KiBSr7cm5z3s3WHQhjekbgAFVbXte6oJNx137A1t',
  price: '71.6 ETH'
},
{
  id: 9896,
  name: 'Bored Ape #9896',
  image: 'https://ipfs.io/ipfs/QmPDFxWv93mwtyx5vwMQWzDdcjYLuj77wMX1cKRU946yZe',
  price: '71.8 ETH'
},
{
  id: 9874,
  name: 'Bored Ape #9874',
  image: 'https://ipfs.io/ipfs/QmanUFRK6MEeWgX47xu222gLhDyz3AFZuoPoeamCgojvPk',
  price: '72.3 ETH'
},
{
  id: 9914,
  name: 'Bored Ape #9914',
  image: 'https://ipfs.io/ipfs/QmWWFNE2rtCR6nnxVpP8tNranwQ3zEPpCkDmRomhhPhDtZ',
  price: '71.9 ETH'
},
{
  id: 9933,
  name: 'Bored Ape #9933',
  image: 'https://ipfs.io/ipfs/QmQCj1ng5Kfn3ZsVJRSTPSdNnBa2q1gYoymfR6NULZmJ5s',
  price: '72.1 ETH'
},
{
  id: 9955,
  name: 'Bored Ape #9955',
  image: 'https://ipfs.io/ipfs/QmSSbKsG2YdQx8uToUtZENroi5xxMUHPAo1Tzy3rLduikt',
  price: '72.4 ETH'
},
{
  id: 9895,
  name: 'Bored Ape #9895',
  image: 'https://ipfs.io/ipfs/QmVrgzXPVWPxEGJk5Uc7rNPJZ3g9b2WgPXuQ3rosRy9n2i',
  price: '71.7 ETH'
},
{
  id: 9952,
  name: 'Bored Ape #9952',
  image: 'https://ipfs.io/ipfs/QmfG9gnVZTPNhANjRxJTQd7j3ZibgQgJJEBfG8W2Vk461Q',
  price: '72.2 ETH'
},
{
  id: 9873,
  name: 'Bored Ape #9873',
  image: 'https://ipfs.io/ipfs/QmNPkkxUMpaemuWxD8GrjHjVfHpcKqUfFKWTtUEDaoXBqg',
  price: '72.0 ETH'
},
{
  id: 9964,
  name: 'Bored Ape #9964',
  image: 'https://ipfs.io/ipfs/QmYhaLZ4cgENgq2yKdh3FmcVg9sCm3ntdFRK9DUGAA4D5L',
  price: '71.5 ETH'
},
{
  id: 9913,
  name: 'Bored Ape #9913',
  image: 'https://ipfs.io/ipfs/QmbA1EZqXA814fJJrBESijwPH9F4WP42zD65JytDGYR5cJ',
  price: '72.5 ETH'
},
{
  id: 9932,
  name: 'Bored Ape #9932',
  image: 'https://ipfs.io/ipfs/QmVKqN9mcbwdLaeLvvoiDJjENu9fn1EVsbmLohgiJb9ZP5',
  price: '71.6 ETH'
},
    {
  id: "9952",
  name: "BAYC #9952",
  image: "https://ipfs.io/ipfs/QmfG9gnVZTPNhANjRxJTQd7j3ZibgQgJJEBfG8W2Vk461Q"
},
{
  id: "9873",
  name: "BAYC #9873",
  image: "https://ipfs.io/ipfs/QmNPkkxUMpaemuWxD8GrjHjVfHpcKqUfFKWTtUEDaoXBqg"
},
{
  id: "9964",
  name: "BAYC #9964",
  image: "https://ipfs.io/ipfs/QmYhaLZ4cgENgq2yKdh3FmcVg9sCm3ntdFRK9DUGAA4D5L"
},
{
  id: "9913",
  name: "BAYC #9913",
  image: "https://ipfs.io/ipfs/QmbA1EZqXA814fJJrBESijwPH9F4WP42zD65JytDGYR5cJ"
},
{
  id: "9932",
  name: "BAYC #9932",
  image: "https://ipfs.io/ipfs/QmVKqN9mcbwdLaeLvvoiDJjENu9fn1EVsbmLohgiJb9ZP5"
},
    {
  id: "9959",
  name: "BAYC #9959",
  image: "https://ipfs.io/ipfs/QmSSYzgfwV7AR8yfT7Ev5KZYnhpvBPCPQdTyjZ7TvvvKXW"
},
{
  id: "9899",
  name: "BAYC #9899",
  image: "https://ipfs.io/ipfs/QmTpJePyM5FnVCPvC6W7FS7k3zaaEM7x7bHJT9SEU1a9eR"
},
{
  id: "9877",
  name: "BAYC #9877",
  image: "https://ipfs.io/ipfs/QmNRtPqzeSa8PZz3npdNN9FoURHWoH2P4UCNsEH9ymH8t9"
},
{
  id: "9936",
  name: "BAYC #9936",
  image: "https://ipfs.io/ipfs/QmcLzFho7TBazZ868EzsmLreSt6ErhdqHofUKa56sEc4p3"
},
{
  id: "9917",
  name: "BAYC #9917",
  image: "https://ipfs.io/ipfs/QmXYthmL6YkqYFSS93uHYED238gk5eoijkLqRfp1r1NDfB"
},
{
  id: "9958",
  name: "BAYC #9958",
  image: "https://ipfs.io/ipfs/QmergasVYr54cDYUdPi6iXYxP4ZorhLJwKQ9rkHjXdRydF"
},
{
  id: "9898",
  name: "BAYC #9898",
  image: "https://ipfs.io/ipfs/QmUQdqVxn2Jhjvzog2mc3zGphtem5LBjjKGn8DHwNkKkaY"
},
{
  id: "9876",
  name: "BAYC #9876",
  image: "https://ipfs.io/ipfs/QmNvXzuWsbHeWFcq2vxTmC9bh2G11o9Vz5pcEJQDKC8R8T"
},
{
  id: "9916",
  name: "BAYC #9916",
  image: "https://ipfs.io/ipfs/QmYJ3KxdX8XNgoiedPvwyyG3227xDHFgs1daBBJtvCr8EW"
},
{
  id: "9935",
  name: "BAYC #9935",
  image: "https://ipfs.io/ipfs/QmXW6qtfJLa9bPKHcwsyN2pZXoZvbvDk5Uqakzi6KTYRXY"
},
{
  id: "9957",
  name: "BAYC #9957",
  image: "https://ipfs.io/ipfs/QmSyhSPMPuiNLWmDRKJShqasBeLpSowwPD3yy2ZFQuWULt"
},
{
  id: "9897",
  name: "BAYC #9897",
  image: "https://ipfs.io/ipfs/Qmb7uyGniYpQJ9FjPjs2Gv1s8GUmN23WdkB2V4HAJzcD6o"
},
{
  id: "9875",
  name: "BAYC #9875",
  image: "https://ipfs.io/ipfs/QmV5W8WfAgTs6bEwULygDfWYfPLkR1XRs4zDwHpZpkogfS"
},
{
  id: "9915",
  name: "BAYC #9915",
  image: "https://ipfs.io/ipfs/QmeRH2bp3cbM3kuEWGn6nDV4BorUCgWpcnwwatkVr3nURw"
},
{
  id: "9934",
  name: "BAYC #9934",
  image: "https://ipfs.io/ipfs/QmYY7pgjdvkLkpMzqNZN993YbYfPN8VZXLCskAvdNwJCXW"
},
{
  id: "9956",
  name: "BAYC #9956",
  image: "https://ipfs.io/ipfs/QmXi74KiBSr7cm5z3s3WHQhjekbgAFVbXte6oJNx137A1t"
},
{
  id: "9896",
  name: "BAYC #9896",
  image: "https://ipfs.io/ipfs/QmPDFxWv93mwtyx5vwMQWzDdcjYLuj77wMX1cKRU946yZe"
},
{
  id: "9874",
  name: "BAYC #9874",
  image: "https://ipfs.io/ipfs/QmanUFRK6MEeWgX47xu222gLhDyz3AFZuoPoeamCgojvPk"
},
{
  id: "9914",
  name: "BAYC #9914",
  image: "https://ipfs.io/ipfs/QmWWFNE2rtCR6nnxVpP8tNranwQ3zEPpCkDmRomhhPhDtZ"
},
{
  id: "9933",
  name: "BAYC #9933",
  image: "https://ipfs.io/ipfs/QmQCj1ng5Kfn3ZsVJRSTPSdNnBa2q1gYoymfR6NULZmJ5s"
},
{
  id: "9955",
  name: "BAYC #9955",
  image: "https://ipfs.io/ipfs/QmSSbKsG2YdQx8uToUtZENroi5xxMUHPAo1Tzy3rLduikt"
},
{
  id: "9895",
  name: "BAYC #9895",
  image: "https://ipfs.io/ipfs/QmVrgzXPVWPxEGJk5Uc7rNPJZ3g9b2WgPXuQ3rosRy9n2i"
}
    
    
];
